var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManageReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 4.449574 12.980824 L 4.449574 23.555398 C 4.449574 24.176847 4.951705 24.674006 5.568182 24.674006 L 11.151278 24.674006 L 11.151278 12.980824 C 11.151278 12.364347 10.649148 11.862216 10.03267 11.862216 L 5.568182 11.862216 C 4.951705 11.862216 4.449574 12.364347 4.449574 12.980824 Z M 4.449574 12.980824 ",
    transform: "matrix(0.785714,0,0,0.785714,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 23.441051 14.96946 L 18.971591 14.96946 C 18.355114 14.96946 17.852983 15.471591 17.852983 16.088068 L 17.852983 24.678977 L 23.441051 24.678977 C 24.057528 24.678977 24.554688 24.176847 24.554688 23.560369 L 24.554688 16.088068 C 24.554688 15.471591 24.057528 14.96946 23.441051 14.96946 Z M 23.441051 14.96946 ",
    transform: "matrix(0.785714,0,0,0.785714,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 11.151278 4.439631 L 11.151278 24.674006 L 17.852983 24.674006 L 17.852983 4.439631 C 17.852983 3.823153 17.355824 3.321023 16.739347 3.321023 L 12.269886 3.321023 C 11.653409 3.321023 11.151278 3.823153 11.151278 4.439631 Z M 11.151278 4.439631 ",
    transform: "matrix(0.785714,0,0,0.785714,0,0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageReports);
export default __webpack_public_path__ + "static/media/manage_reports.0263f14113fff0fb159e1fc8e47b3672.svg";
export { ForwardRef as ReactComponent };